import clsx from 'clsx';
import styles from './InlineButton.module.scss';

interface InlineButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  testId?: string;
  size?: 'inherit' | 'sm' | 'md';
  currentColor?: boolean;
  weight?: 'normal' | 'strong';
}

export const InlineButton: React.FC<InlineButtonProps> = ({
  children,
  testId,
  size = 'inherit',
  currentColor = false,
  weight = 'normal',
  ...props
}) => (
  <button
    type={props.type || 'button'}
    className={clsx(styles.button, styles[`size-${size}`], {
      [styles.currentColor]: currentColor,
      [styles.weightStrong]: weight === 'strong',
    })}
    data-testid={testId}
    {...props}
  >
    {children}
  </button>
);
